<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200" data-tour-id="tryb-cen">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Tryb wprowadzania cen</div>
            <div class="text-md text-secondary">Określ, czy ceny w pozycjach faktur wprowadzane są jako kwoty netto czy brutto</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-select [formControl]="control" matInput>
                <mat-option [value]="mode.id" *ngFor="let mode of modes">
                    {{mode.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
